import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import LandingPage from './components/LandingPage';
import HomePage from './components/HomePage';
import AppraiserConsole from './components/AppraiserConsole';
import HomeownerConsole from './components/HomeownerConsole';
import Login from './components/Login';
import SSOCallback from './components/SSOCallback';
import InspectRedirect from './components/InspectRedirect';
import Signup from './components/Signup';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import PrivacyPolicy from './components/PrivacyPolicy';
import ProtectedRoute from './components/ProtectedRoute';
import './App.css';

function App() {
  return (
    <Router>
      <AuthProvider>
        <div className="App">
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/auth/sso/callback" element={<SSOCallback />} />
            <Route path="/inspect" element={<InspectRedirect />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <HomePage />
              </ProtectedRoute>
            } />
            <Route path="/appraiser" element={<AppraiserConsole />} />
            <Route path="/homeowner" element={<HomeownerConsole />} />
          </Routes>
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;
